import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-green-50 border-y border-green-100" data-id="element-67">
      <div className="max-w-3xl mx-auto text-center" data-id="element-68">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-6 shadow-inner" data-id="element-69">
          <ShieldCheckIcon className="w-10 h-10 text-green-600" data-id="element-70" />
        </div>

        <h2 className="text-3xl md:text-4xl font-black text-green-900 mb-6" data-id="element-71">
          🔒 GARANTÍA TOTAL DE 7 DÍAS
        </h2>

        <div className="space-y-4 text-lg md:text-xl text-green-800 leading-relaxed" data-id="element-72">
          <p className="font-bold text-2xl" data-id="element-73">
            Si en 7 días no ves ningún cambio, te devuelvo el 100% de tu dinero.
          </p>
          <p data-id="element-74">Sin preguntas. Sin formularios raros. Sin drama.</p>
          <p data-id="element-75">Solo escribime y listo.</p>
          <p className="bg-white/60 p-4 rounded-lg mt-6 font-medium" data-id="element-76">
            Porque estoy tan segura de que esto funciona, que{' '}
            <strong className="text-green-900" data-id="element-77">el riesgo lo asumo yo.</strong>
            <br data-id="element-78" />
            Vos solo tenés que abrir la primera guía.
          </p>
        </div>
      </div>
    </section>;
}